import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import AuthCallback from "@/pages/AuthCallback";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Plaza from "@/pages/Plaza";
import StudyDetail from "@/pages/StudyDetail";
import Scripture from "@/pages/Scripture";
import CreateStudy from "@/pages/CreateStudy";
import HostManage from "@/pages/HostManage";
import Upgrade from "@/pages/Upgrade";
import Account from "@/pages/Account";
import InviteJoin from "@/pages/InviteJoin";
import BrandDownloads from "@/pages/BrandDownloads";
import CuratorDashboard from "@/pages/CuratorDashboard";
import CuratorGroup from "@/pages/CuratorGroup";
import MinistryNew from "@/pages/MinistryNew";
import DonateSuccess from "@/pages/DonateSuccess";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="grid min-h-screen place-items-center text-[#6B6763]">Loading…</div>;
  if (!user) return <Navigate to="/auth" replace />;
  return children;
}

function Root() {
  return <Landing />;
}

function AppRoutes() {
  const location = useLocation();
  // OAuth callback: Emergent returns to {origin}/plaza#session_id=... — handle it
  // before any protected-route/auth checks to avoid race conditions.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Root />} />
      <Route path="/auth" element={<AuthPage />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/plaza" element={<Layout><Plaza /></Layout>} />
      <Route path="/scripture" element={<Layout><Scripture /></Layout>} />
      <Route path="/study/:id" element={<Layout><StudyDetail /></Layout>} />
      <Route path="/upgrade" element={<Layout><Upgrade /></Layout>} />
      <Route path="/invite/:token" element={<Layout><InviteJoin /></Layout>} />
      <Route path="/brand" element={<Layout><BrandDownloads /></Layout>} />
      <Route path="/curator" element={<Protected><CuratorDashboard /></Protected>} />
      <Route path="/curator/ministry/new" element={<Protected><MinistryNew /></Protected>} />
      <Route path="/curator/:id" element={<Protected><CuratorGroup /></Protected>} />
      <Route path="/donate/success" element={<DonateSuccess />} />
      <Route path="/payment/success" element={<Layout><PaymentSuccess /></Layout>} />
      <Route path="/payment/cancel" element={<Layout><PaymentCancel /></Layout>} />
      <Route path="/account" element={<Protected><Layout><Account /></Layout></Protected>} />
      <Route path="/host/new" element={<Protected><Layout><CreateStudy /></Layout></Protected>} />
      <Route path="/host/:id" element={<Protected><Layout><HostManage /></Layout></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
